<template>
  <div>
    <!-- <router-view /> -->
     <keep-alive>
        <router-view v-if="$route.meta.keepAlive">
          <!-- 这里是会被缓存的视图组件-->
        </router-view>
      </keep-alive>

      <router-view v-if="!$route.meta.keepAlive"></router-view>
      <!-- 这里是不被缓存的视图组件 -->
  </div>
</template>

<script>
export default {
  name: "NoHeadAndFoot",
};
</script>

<style lang="scss">
body {
  margin: 0;
  padding: 0;
}
.content {
  width: 100%;
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/layout/NoHeadAndFoot.vue